
import React, { useState } from 'react';
import SubscriptionStatusSelect from './SubscriptionStatusSelect';
import CancelSubscriptionDialog from './CancelSubscriptionDialog';
import { useSubscriptionStatusChange } from '@/hooks/admin/subscription/useSubscriptionStatusChange';

interface SubscriptionStatusDropdownProps {
  currentPlan: string;
  customerId: string;
  subscriptionId: string | null;
  stripeSubscriptionId: string | null;
  onUpdatePlan: (subscriptionId: string, newPlan: string) => Promise<boolean>;
  onCreateSubscription: (userId: string, plan: string) => Promise<boolean>;
  onCancelSubscription: (userId: string, stripeSubscriptionId: string | null, shouldRefund?: boolean) => Promise<boolean>;
}

const SubscriptionStatusDropdown: React.FC<SubscriptionStatusDropdownProps> = ({
  currentPlan,
  customerId,
  subscriptionId,
  stripeSubscriptionId,
  onUpdatePlan,
  onCreateSubscription,
  onCancelSubscription
}) => {
  const [showCancelDialog, setShowCancelDialog] = useState(false);
  
  const { 
    handleChange, 
    isUpdating, 
    setIsUpdating,
    normalizedCurrentPlan
  } = useSubscriptionStatusChange({
    currentPlan,
    customerId,
    subscriptionId,
    onUpdatePlan,
    onCreateSubscription,
    onShowCancelDialog: () => setShowCancelDialog(true)
  });

  const handleCancel = async (shouldRefund: boolean = false) => {
    setIsUpdating(true);
    try {
      const success = await onCancelSubscription(customerId, stripeSubscriptionId, shouldRefund);
      
      if (!success) {
        console.error("Failed to cancel subscription");
      }
    } catch (error) {
      console.error('Error canceling subscription:', error);
    } finally {
      setIsUpdating(false);
      setShowCancelDialog(false);
    }
  };

  return (
    <>
      <SubscriptionStatusSelect 
        currentValue={normalizedCurrentPlan}
        isUpdating={isUpdating}
        onValueChange={handleChange}
      />

      <CancelSubscriptionDialog
        open={showCancelDialog}
        onOpenChange={setShowCancelDialog}
        onCancel={handleCancel}
        isUpdating={isUpdating}
        hasStripeSubscription={!!stripeSubscriptionId}
      />
    </>
  );
};

export default SubscriptionStatusDropdown;
